module.exports = __webpack_public_path__ + "static/media/icon-cancel.f5ffa542.svg";